export const TAGS_MANAGEMENT_FORM_MODES = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
}
